import { FormGroup, FormParagraph, Select } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedLanguage } from '@frontend/translate';
import type { IReduxState } from '../../../../configureStore';
import type { IOption } from '../../../interfaces/option';
import { useAbortableFetch } from '../../../../utils/hooks/useAbortableFetch';
import { convertApiResponseToOptions } from './utils';

interface IGeneralSettingsSpecializationProps {
    currentSpecializations: IOption<string>[];
    employmentId: string;
    isDisabled?: boolean;
    isEditing: boolean;
    onChange: (value: IOption<string>[]) => void;
    placeHolderMessage?: string;
    showTooltip: boolean;
}

export function GeneralSettingsSpecialization(props: IGeneralSettingsSpecializationProps) {
    const abortableFetch = useAbortableFetch();
    const language = useSelector((state: IReduxState) => state.language.code);

    const translate = getSelectedLanguage();

    const [specializations, setSpecialization] = useState<IOption<string>[]>([]);

    useEffect(() => {
        loadSpecializations();
    }, []);

    return (
        <FormGroup
            label={translate.serviceProvider.specializations}
            tooltipText={props.showTooltip ? translate.personalSettings.specializationsTooltip : ''}
        >
            {props.isEditing ? (
                <Select
                    closeMenuOnSelect={false}
                    defaultValue={props.currentSpecializations.length > 0 ? props.currentSpecializations : undefined}
                    isClearable={false}
                    isDisabled={props.isDisabled}
                    isMulti={true}
                    noOptionsMessage={() => ''}
                    onChange={(value: any) => handleChange(value)}
                    options={specializations}
                    placeholder={props.placeHolderMessage ?? translate.carePath.selectSpecialization}
                />
            ) : (
                <FormParagraph>
                    {props.currentSpecializations.map((specialization) => specialization.label).join(', ') || '-'}
                </FormParagraph>
            )}
        </FormGroup>
    );

    async function loadSpecializations() {
        const url = `/api/specializations?employmentId=${props.employmentId}`;
        const result = await abortableFetch.fetchJson(url, 'GET');

        setSpecialization(convertApiResponseToOptions(result.json.items, language));
    }

    async function handleChange(value: IOption<string>[]) {
        props.onChange(value);
    }
}
